import { RootState } from 'handlers';

export const getApplicationData = ({ applicationData }: RootState) => applicationData;
